import { render, staticRenderFns } from "./QuizTutorial.vue?vue&type=template&id=16c971a4&"
import script from "./QuizTutorial.vue?vue&type=script&lang=js&"
export * from "./QuizTutorial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports